import { Reporter } from '../reporter/Reporter'

type props = { text?: string }

export const Casein: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'Casein'}
      link="https://us.myprotein.com/sports-nutrition/slow-release-casein/11092497.html"
    />
  </div>
)

export const Erythritol: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'Erythritol'}
      link="https://www.amazon.com/Erythritol-Granules-Anthonys-Non-GMO-Sweetener/dp/B018UWALFS" // https://amzn.to/2JuFLLP
    />
  </div>
)

export const MSG: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'MSG'}
      link="https://www.amazon.com/McCormick-Culinary-Flavor-Enhancer-Msg/dp/B008OGCKSC" // https://amzn.to/36L5pof
    />
  </div>
)

export const Pea: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'Pea'}
      link="https://us.myprotein.com/sports-nutrition/pea-protein-isolate/10852589.html"
    />
  </div>
)

export const PopcornSeasoning: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'Popcorn Seasoning'}
      link="https://www.amazon.com/Kernel-Seasons-Popcorn-Seasoning-Parmesan/dp/B00DBC0ZRC" // https://amzn.to/2IfNnkw
    />
  </div>
)

export const Rice: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      link="https://us.myprotein.com/sports-nutrition/brown-rice-protein/10852398.html"
      text={text}
      defaultText={'Rice'}
    />
  </div>
)

export const Soy: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'Soy'}
      link="https://us.myprotein.com/sports-nutrition/soy-protein-isolate/10852597.html"
    />
  </div>
)

export const Stevia: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'Stevia'}
      link="https://www.amazon.com/CCnature-substitute-stevia-natural-healthy/dp/B089356341" // https://amzn.to/36L5xEf
    />
  </div>
)

export const Sucralose: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'Sucralose'}
      link="https://www.amazon.com/SucraDrops-Premium-Sucralose-Sweetener-Servings/dp/B00VL9Q4WW" // https://amzn.to/3oEw3FS
    />
  </div>
)

export const TVP: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'TVP'}
      link="https://www.amazon.com/Anthonys-Textured-Vegetable-Protein-Unflavored/dp/B07SPWJ8QH"
      // https://amzn.to/3lKWvvo
    />
  </div>
)

export const Whey: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'Whey'}
      link="https://us.myprotein.com/sports-nutrition/impact-whey-protein/10852500.html"
    />
  </div>
)
